import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-oval-shaped-graph-label',
    templateUrl: './oval-shaped-graph-label.component.html',
    styleUrls: ['./oval-shaped-graph-label.component.scss'],
    standalone: false
})
export class OvalShappedGraphLabelComponent{
  @Input() label!: string;
}